var _path, _path2, _path3, _path4, _path5, _circle, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllDevices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.1065 43.2905H24.6849L23.8164 51.1068H35.9751L35.1065 43.2905Z",
    fill: "url(#paint0_linear_250_7209)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5476 13.4287H8.26187C7.28873 13.4287 6.5 14.2047 6.5 15.162V39.4287H52.3095V15.162C52.3094 14.2047 51.5207 13.4287 50.5476 13.4287Z",
    fill: "url(#paint1_linear_250_7209)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.26188 44.3809H50.5476C51.5208 44.3809 52.3095 43.4572 52.3095 42.3175V38.1904H6.5V42.3175C6.5 43.4572 7.28873 44.3809 8.26188 44.3809Z",
    fill: "url(#paint2_linear_250_7209)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5435 35.7144H49.3326C48.3733 35.7144 47.5957 36.4919 47.5957 37.4513V49.6099C47.5957 50.5693 48.3733 51.3469 49.3326 51.3469H54.5435C55.5029 51.3469 56.2804 50.5693 56.2804 49.6099V37.4513C56.2804 36.4919 55.5029 35.7144 54.5435 35.7144Z",
    fill: "url(#paint3_linear_250_7209)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8816 27.9764H30.2625C29.4078 27.9764 28.7149 28.6693 28.7149 29.524V49.3335C28.7149 50.1882 29.4078 50.8811 30.2625 50.8811H43.8816C44.7363 50.8811 45.4292 50.1882 45.4292 49.3335V29.524C45.4292 28.6693 44.7363 27.9764 43.8816 27.9764Z",
    fill: "url(#paint4_linear_250_7209)",
    stroke: "#595467",
    strokeWidth: 0.619048
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 51.9286,
    cy: 49.9523,
    r: 0.619048,
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6 52C17.6 52 27.2 47.2 27.2 40V31.6L17.6 28L8 31.6V40C8 47.2 17.6 52 17.6 52Z",
    fill: "url(#paint5_linear_250_7209)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 39.25L16.625 43.375L23 37",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_250_7209",
    x1: 29.8957,
    y1: 43.2905,
    x2: 29.8957,
    y2: 51.1068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#898989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2C2C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_250_7209",
    x1: 19.5,
    y1: 13.4287,
    x2: 32.5,
    y2: 43.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7AAFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9494"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_250_7209",
    x1: 29.4048,
    y1: 38.1904,
    x2: 29.4048,
    y2: 44.3809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_250_7209",
    x1: 51.9381,
    y1: 35.7144,
    x2: 51.9381,
    y2: 51.3469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FA9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_250_7209",
    x1: 37.072,
    y1: 28.2859,
    x2: 37.072,
    y2: 50.5716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EB1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83E9D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_250_7209",
    x1: 17.6,
    y1: 28,
    x2: 17.6,
    y2: 52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71FFD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DF74",
    stopOpacity: 0.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllDevices);
export default __webpack_public_path__ + "static/media/allDevices.fe99b06667d2b8ace5995da25d5de576.svg";
export { ForwardRef as ReactComponent };